import { render, staticRenderFns } from "./breathe.html?vue&type=template&id=a64320c0&"
import script from "./breathe.js?vue&type=script&lang=js&"
export * from "./breathe.js?vue&type=script&lang=js&"
import style0 from "./breathe.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports